import postAPI from './postAPI.js'

export default async function postInitiateStepSigning(body) {
    const data = await postAPI('taskinstances/steps/signing/initiate', body);
    return data;
}
